__turbopack_context__.v({
  "root": "C6xt3q_root",
  "wrapper": "C6xt3q_wrapper",
});
